import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CognitoUserPool } from "amazon-cognito-identity-js";

// Cognito configuration
const COGNITO_CONFIG = {
  userPoolId: "us-east-1_fc1omeTGh",
  clientId: "54fiucjkk95o6gna3l5l3dnjuo",
  region: "us-east-1",
};

// Create the Cognito User Pool object
const userPool = new CognitoUserPool({
  UserPoolId: COGNITO_CONFIG.userPoolId,
  ClientId: COGNITO_CONFIG.clientId,
});

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Handle logout
    const handleLogout = () => {
      // Clear token
      sessionStorage.removeItem("cognitoIdToken");

      // Sign out of Cognito
      const currentUser = userPool.getCurrentUser();
      if (currentUser) {
        currentUser.signOut();
      }

      // Trigger storage event so navbar updates
      window.dispatchEvent(new Event("storage"));

      // Redirect to home page
      navigate("/");
    };

    // Perform logout immediately when the component mounts
    handleLogout();
  }, [navigate]);

  return (
    <div className="logout-container">
      <div className="logout-message">
        <h2>Logging out...</h2>
        <p>You will be redirected to the home page.</p>
      </div>
    </div>
  );
};

export default Logout;
